<template>
  <div class="nav-wrap">
    <div class="logo-wrap">
      <media :query="{ maxWidth: 529 }">
        <PromoLogo class="logo" />
      </media>
      <media :query="{ minWidth: 530 }">
        <PromoLogo full class="logo" />
      </media>
    </div>

    <div class="flex flex-col ml-auto md:hidden">
      <nav class="nav">
        <button
          class="sidebar-toggle"
          :class="{ active: sidebarActive }"
          @click="$emit('update:sidebarActive', !sidebarActive)"
        >
          <v-icon slot="icon-end" name="bars" />
        </button>
      </nav>
    </div>

    <media :query="{ minWidth: screens.md }">
      <nav class="nav ml-auto">
        <div class="hidden md:flex">
          <router-link class="nav-link mr-4" to="/templates">
            Templates
          </router-link>
          <router-link class="nav-link" to="/campaigns">
            Campaigns
          </router-link>
        </div>

        <div class="flex items-center ml-auto">
          <a
            class="meta-link ml-3"
            href="http://help.promo.ai/category/newsletters-by-promo-ai/"
            target="_blank"
          >
            <v-icon
              slot="icon-start"
              name="question"
              scale=".7"
              class="meta-link-icon"
            />
            Help
          </a>

          <router-link is="Button" class="meta-link ml-3" to="/plans">
            <v-icon
              slot="icon-start"
              name="regular/credit-card"
              scale=".7"
              class="meta-link-icon mr-1"
            />
            Change Plan
          </router-link>

          <Button class="meta-link ml-3" @click="$emit('logout-click')">
            <v-icon
              slot="icon-start"
              name="sign-out-alt"
              class="meta-link-icon mr-1"
              scale=".8"
            />
            Logout
          </Button>
        </div>
      </nav>
    </media>
  </div>
</template>

<script>
import Media from "vue-media";

import PromoLogo from "@/components/UI/PromoLogo";

export default {
  name: "PromoHeader",
  inject: ["screens"],
  components: { Media, PromoLogo },
  props: {
    sidebarActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.nav-wrap {
  @apply flex flex-wrap bg-white border-b border-grey-light;
}

.nav {
  @apply flex items-center justify-end flex-wrap flex-1 p-6;

  @screen lg {
    @apply justify-between;
  }
}

.nav-link {
  @apply text-support font-sans font-normal px-0 no-underline;

  &:hover {
    @apply no-underline text-brand;
  }

  &.router-link-exact-active {
    @apply no-underline text-brand font-lato font-bold;
  }
}

.meta-link {
  @apply nav-link text-xs;
}

.meta-link-icon {
  @apply text-support-lightest;
}

.logo-wrap {
  @apply flex items-center flex-no-shrink px-6 bg-grey-lightest border-r border-grey-light;
}

.logo {
  max-width: 110px;

  @screen sm {
    max-width: 150px;
  }
}

.sidebar-toggle {
  @apply flex items-center px-3 py-2 text-support-light outline-none leading-none;
  transition: transform 150ms ease-in;

  &:hover,
  &.active {
    @apply text-brand-alt;
  }

  &.active {
    transform: rotate(90deg);
  }

  &:focus {
    @apply outline-none;
  }
}
</style>
